import { Component, ChangeDetectionStrategy, input, output, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-liste-tekrar',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="liste-kapsayici">
      @for (item of veriler(); track $index) {
        @if (itemSablon()) {
          <ng-container *ngTemplateOutlet="itemSablon()!; context: { $implicit: item, index: $index }" />
        } @else {
          <div class="liste-satir" (click)="itemTiklandi.emit(item)">
            @if (item?.simge) { <span class="satir-simge">{{ item.simge }}</span> }
            <div class="satir-icerik">
              <span class="satir-baslik">{{ item?.baslik ?? item?.isim ?? item }}</span>
              @if (item?.aciklama) { <span class="satir-aciklama">{{ item.aciklama }}</span> }
            </div>
          </div>
        }
      }
    </div>
  `,
  styles: [`
    :host { display: block; }
    .liste-kapsayici { display: flex; flex-direction: column; }
    .liste-satir {
      display: flex; align-items: center; gap: 10px;
      padding: 8px 12px; cursor: pointer;
      transition: background 0.2s;
    }
    .liste-satir:hover { background: var(--py-hover, rgba(0,0,0,0.04)); }
    .satir-simge { font-size: 18px; flex-shrink: 0; }
    .satir-icerik { display: flex; flex-direction: column; min-width: 0; }
    .satir-baslik {
      font-size: 13px; font-weight: 500;
      color: var(--py-metin, #262626);
      overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
    }
    .satir-aciklama {
      font-size: 11px; opacity: 0.55; margin-top: 1px;
      overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
    }
  `],
})
export class ListeTekrarComponent {
  veriler = input<any[]>([]);
  itemSablon = input<TemplateRef<any> | null>(null);
  itemTiklandi = output<any>();
}
